import { createLucideIcon } from 'lucide-react';

export const MultiLineChart = createLucideIcon('MultiLineChart', [
  ['path', { d: 'M3 3v16a2 2 0 0 0 2 2h16', key: 'axes' }],
  ['path', { d: 'm5 17 4-5 4 3 6-8', key: 'series1' }],
  ['path', { d: 'm5 11 4-2 4-2 6-3', key: 'series2' }],
]);

export const customIcons = {
  MultiLineChart,
} as const;
